/* eslint no-template-curly-in-string: ['off'] */
import { Predicate } from '@syncfusion/ej2-data';
import { Selector } from '@felicity/data-management';
import OwnerDataSource from '../data/OwnerDataSource.mjs';

/**
 * Drop down list for selecting a single assessment tool owner user
 */
export default class OwnerSelector extends Selector {
  textField = 'name';
  valueField = 'id';
  groupByField = 'role';

  /* eslint class-methods-use-this: ['off'] */
  prepareFilter = (text, query) => {
    const predicate = new Predicate('name', 'contains', text, true)
      .or('role', 'startsWith', text, true);

    return query.where(predicate);
  };

  constructor() {
    super();

    this.dataSource = OwnerDataSource.getDataSource();
  }
}
